import { Tooltip } from '@mui/material'


const MaterialTooltip = ({ text, title, placement='top' }) => {
  return (
    <Tooltip title={text} placement={placement}>
      <span>{title}</span>
    </Tooltip>
  )
}

export default MaterialTooltip
